import type { Container } from "inversify";
import ApiService from "@/src/application/services/api-service";
import {
  AuthApi,
  CompositeDataApi,
  DeviceApi,
  DeviceLinkClaimsApi,
  MeasurementApi,
  NotificationApi,
  UserApi,
} from "@generated/n3-backend-api";

export function registerN3Backend(container: Container) {
  container
    .bind<UserApi>(UserApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new UserApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<DeviceApi>(DeviceApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new DeviceApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<DeviceLinkClaimsApi>(DeviceLinkClaimsApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new DeviceLinkClaimsApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<MeasurementApi>(MeasurementApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new MeasurementApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();
  container
    .bind<AuthApi>(AuthApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new AuthApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<CompositeDataApi>(CompositeDataApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new CompositeDataApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();

  container
    .bind<NotificationApi>(NotificationApi)
    .toDynamicValue((context) => {
      const axiosInstance = context.get(ApiService).getAxiosInstance();
      return new NotificationApi(undefined, undefined, axiosInstance);
    })
    .inSingletonScope();
}
